import React, { useEffect, useContext, useState } from 'react';
import { appContext } from "./../../../AppContext";
import {useFetch} from '../../../utils/hooks/useFetch'
import { Spin, message } from 'antd';
import SkillWikiModal from './SkillWikiModal';
import skillColumns, { skillsList } from '../columns/skillColumns';
import LarpTable from '../../table/LarpTable';

export default function SkillWiki({
  allSkills
}) {

     const [appState] = useContext(appContext);
     const [doFetch] = useFetch();
     const[isLoading, setIsLoading] = useState(true)
     const [searchValue, setSearchValue] = useState("");
     const [dataSource, setDataSource] = useState([]);
     const [listSource, setListSource] = useState([]);
     const [result, setResult] = useState([])
     const [isModalVisible, setIsModalVisible] = useState(false);
     const [selectedRecord, setSelectedRecord] = useState({});
     const [allRaces, setAllRaces] = useState([])

      useEffect(() => {
        if(result === undefined || result.length <= 0) {
          return;
        }
        const newDataSource = result.filter(_ => _.name?.toLowerCase().includes(searchValue.toLowerCase())
                                                ||  _.skillPointType?.name?.toLowerCase().includes(searchValue.toLowerCase())
        )
        setDataSource(newDataSource);
        setListSource(skillsList(newDataSource, appState, onRowClick, allRaces, result))
      }, // eslint-disable-next-line
      [result, searchValue, allRaces])

      useEffect(() => {
        refresh();
          }, // eslint-disable-next-line
      [appState.storyId])

      function refresh()
      {
          if(allSkills === undefined) {
            setResult(allSkills);
            setIsLoading(false);
          }
          const url = `/api/skill/GetWiki`
          doFetch(url)
          .then((response) => onInventoryLoaded(response.isSuccess, response.result))
  
          function onInventoryLoaded(isSuccess, result) { 
            if(isSuccess) {
              setResult(result);
              setIsLoading(false);
              return;
            }
            setResult([])
            message.error('Could not get Skills');
            setIsLoading(false);
          }
      }

      useEffect(() => {
        const url = `/api/race/${appState.storyId}/GetWiki`
        doFetch(url)
            .then((response) => onInventoryLoaded(response.isSuccess, response.result))

        function onInventoryLoaded(isSuccess, result) { 
        if(isSuccess) {
            setAllRaces(result);
            return;
        }
        setAllRaces([])
        message.error('Could not get Races');
        }
    }, // eslint-disable-next-line
    [])

      if(isLoading)
      {
          return <Spin />
      }

      function onRowClick(record)
      {
        setSelectedRecord(record);
        setIsModalVisible(true);
      }

      const columns = skillColumns(appState, allRaces, result, onRowClick);

    return (
      <>
          <LarpTable 
            columns={columns}
            dataSource={dataSource}
            listSource={listSource}
            onRowClick={onRowClick}
            setSearchValue={setSearchValue}
            refresh={refresh}
          />

          <SkillWikiModal 
            setIsModalVisible={setIsModalVisible}
            isModalVisible={isModalVisible}
            record={selectedRecord}
            allSkills={result}
            allRaces={allRaces}
          />         
      </>
    )
}